import React, { useState } from 'react';
import Utils from '../../helpers/Utils';
import Input from '../../components/Input';
import Button from '../../components/Button';
import AuthPage, { AuthLink } from '../../components/AuthPage';
import useAPI from '../../hooks/useAPI';
import { useFormatter } from '../../hooks/useFormatter';
import useFlash from '../../hooks/useFlash';
import FlashMessage from '../../components/FlashMessage';

export default function ForgotPassword () {
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [errors, setErrors] = useState({
        email: '',
    });

    const api = useAPI();
    const formatter = useFormatter();
    const { messages, flash, remove } = useFlash();

    const resetPassword = (e) => {
        e.preventDefault();

        let _errors = {};
        if (!email) {
            _errors.email = "Email address required";
        } else if (!Utils.emailValid(email)) {
            _errors.email = "Email address invalid";
        }

        setErrors(_errors);

        if (Object.keys(_errors).length) {
            return setErrors(_errors);
        }

        setBusy(true);

        api.json('POST', '/auth/request-password-reset', {
            email,
        })
            .then(r => r.json())
            .then((response) => {
                if (response.errors) {
                    return setErrors({
                        ...errors,
                        ...formatter.flattenErrors(response.errors)
                    });
                }

                flash('Password reset sent. Please check your email for further instructions.', 'success');
                setEmail('');
            })
            .catch((error) => {
                alert(error);
            })
            .then(() => setBusy(false));
    };

    return (
        <AuthPage title="Reset your password">
            <FlashMessage messages={messages} onRemove={remove} />
            <div className="row">
                <div className="col-12">
                    <Input
                        error={errors.email}
                        placeholder="tom@example.com"
                        label="Email Address"
                        maxLength="128"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setErrors({ ...errors, email: '' });
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Button
                        busy={busy}
                        className="button-full button-primary"
                        onClick={resetPassword}
                    >
                        Reset Password
                    </Button>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <AuthLink to={`/login`}>Nevermind, go back to login</AuthLink>
                </div>
            </div>
        </AuthPage>
    );
};